import { createEvent, restore, sample } from 'effector'
import {
  ExchangerTransfer,
  ExchangerTransfersRequest,
  ExchangerTransfersResponse,
} from './types'
import { fx } from '../../../../libs'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const exchangerTransfersListMounted =
  createEvent<ExchangerTransfersRequest>()

export const getExchangerTransfers = fx<
  ExchangerTransfersRequest,
  ExchangerTransfersResponse
>({
  method: 'GET',
  url: `/exchanger_transfer`,
})

export const $exchangerTransfers = restore<ExchangerTransfer[]>(
  getExchangerTransfers.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfExchangerStatistic = restore(
  getExchangerTransfers.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: exchangerTransfersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    // if (filters) {
    //   //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
    //   let newObj = Object.keys(filters).reduce((accumulator, key) => {
    //     if (filters[key as keyof typeof filters] != null) {
    //       accumulator[key as keyof typeof filters] =
    //         key === 'type' || key === 'active'
    //           ? filters[key as keyof typeof filters]
    //           : `${filters[key as keyof typeof filters]}`
    //     }
    //
    //     return accumulator
    //   }, {} as any)
    //
    //   if (!isAllElementsOfSearchTextNotExist(searchText)) {
    //     newObj = { ...newObj, ...mapSearchText(searchText) }
    //   }
    //
    //   if (Object.keys(newObj).length) {
    //     // @ts-ignore
    //     query['where'] = `${JSON.stringify(newObj)}`
    //   }
    // }

    // @ts-ignore
    query['populate'] = '["ExchangerTransfer.client"]'

    return {
      query,
    }
  },
  target: getExchangerTransfers,
})
